import i18n from '../i18n';

export default {
  getQuestionTypes: () => [
    {
      label: i18n.t('u.c.contactus.question.type.account', 'Account'),
      options: [
        {
          value: 'Q01_ACCOUNT_MANAGEMENT',
          label: i18n.t(
            'u.c.contactus.question.type.account.management',
            'Management'
          ),
        },
        {
          value: 'Q02_ACCOUNT_BILLING_INFORMATION',
          label: i18n.t(
            'u.c.contactus.question.type.account.billing.info',
            'Billing Information'
          ),
        },
      ],
    },
    {
      label: i18n.t('u.c.contactus.question.type.purchase', 'Purchase'),
      options: [
        {
          value: 'Q03_PURCHASE_PAYMENT',
          label: i18n.t(
            'u.c.contactus.question.type.purchase.payment',
            'Payment'
          ),
        },
        {
          value: 'Q04_PURCHASE_PRODUCT_INFORMATION',
          label: i18n.t(
            'u.c.contactus.question.type.purchase.product.info',
            'Product Information'
          ),
        },
      ],
    },
    {
      label: i18n.t('u.c.contactus.question.type.feature', 'Feature'),
      options: [
        {
          value: 'Q05_FEATURE_HOWTO',
          label: i18n.t(
            'u.c.contactus.question.type.feature.howto',
            'How do I/How to'
          ),
        },
        {
          value: 'Q06_FEATURES_ISSUES',
          label: i18n.t(
            'u.c.contactus.question.type.feature.issues',
            'Issues/Errors/Trouble'
          ),
        },
        {
          value: 'Q08_SHOPIFY_RELATED',
          label: i18n.t(
            'u.c.contactus.question.type.feature.shopify',
            'Shopify Related'
          ),
        },
      ],
    },
    {
      label: i18n.t('u.c.contactus.question.type.others', 'Others'),
      options: [
        {
          value: 'Q07_OTHERS',
          label: i18n.t('u.c.contactus.question.type.others', 'Others'),
        },
      ],
    },
  ],
};
